import { render, staticRenderFns } from "./RegistroDispositivo.vue?vue&type=template&id=5aa24a4e"
import script from "./RegistroDispositivo.vue?vue&type=script&lang=ts"
export * from "./RegistroDispositivo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports